import React from 'react'
import {Card} from 'react-bootstrap'
import {ImLibrary as LibraryIcon} from 'react-icons/im'
import {BsArrowLeftRight as LoanIcon} from 'react-icons/bs'
import NoContentForFullScreen from '../../../common/NoContentForFullScreen'
import CardBodyContentContainer from '../../../common/styles/CardBodyContentContainer'
import CardTitle from '../../../common/styles/CardTitle'
import booksitoutIcon from '../../../config/BooksitoutIcon'
import LibraryTextWithIcon from '../find/LibraryTextWithIcon'
import utils from '../../../common/utils'
import AllButton from '../../../common/button/AllButton'
import styled from 'styled-components'
import Modal from "../../../common/Modal";
import LibraryCard from "../find/LibraryCard";

const LibraryMembershipDetailLibraryCard = ({libraryList}) => {
    const [modalOpen, setModalOpen] = React.useState<boolean>(false)
    const openModal = () => {
        setModalOpen(true)
    }

    return (
        <Card style={{minHeight: '450px'}}>
            <LibraryMembershipDetailModal modalOpen={modalOpen} setModalOpen={setModalOpen} libraryList={libraryList}/>

            <CardBodyContentContainer>
                <CardTitle icon={<LibraryIcon/>} title={`사용할 수 있는 도서관 (${libraryList.length}곳)`} subTitle={undefined}
                           textSize={2} url={''}/>

                {libraryList.length === 0 ? (
                    <NoContentForFullScreen message="아직 추가중이에요"/>
                ) : (
                    <div className="row">
                        {libraryList.slice(0, 12).map(library => {
                            return (
                                <div className="col-12 col-sm-6 col-lg-4">
                                    <LibraryMembershipDetailLibraryCardCard library={library}/>
                                </div>
                            )
                        })}
                    </div>
                )}

                {libraryList.length > 12 && <AllButton url="" onClick={openModal}/>}
            </CardBodyContentContainer>
        </Card>
    )
}

const LibraryMembershipDetailLibraryCardCard = ({library}) => {
    return (
        <a href={`/library/${library.id}`}>
            <Card className="mb-3" style={{minHeight: '125px'}}>
                <CardBodyContentContainer backgroundColorType={'card-card'}>
                    <div className="row">
                        <div className={library.location.distance !== 0 ? 'col-8' : 'col-12'}
                             style={{display: 'flex', gap: 4, alignItems: 'center'}}>
                            <LibraryImage src={library.location.logo}/>
                            <h4 className="clamp-1-line">{library.name}</h4>
                        </div>

                        {library.location.distance !== 0 && (
                            <div className="col-4">
                                <h5 className="text-end text-secondary">{library.location.distance?.toFixed(2) ?? '-'} km</h5>
                            </div>
                        )}
                    </div>

                    <div className="ms-4">
                        <LibraryTextWithIcon icon={<booksitoutIcon.location/>} text={library.location.address}/>
                        <LibraryTextWithIcon icon={<booksitoutIcon.book/>}
                                             text={library.bookCount === 0 ? '-' : `${utils.insertCommas(library.bookCount)} 권`}/>
                        <LibraryTextWithIcon icon={<LoanIcon/>} text={getLoanText(library)}/>
                    </div>
                </CardBodyContentContainer>
            </Card>
        </a>
    )
}

const getLoanText = (library) => {
    const loanText = [
        library.loanBookLimit != null ? `${library.loanBookLimit}권` : null,
        library.loanDayLimit != null ? `${library.loanDayLimit}일` : null,
    ].filter(Boolean).join(' · ')

    return loanText || '-'
}

const LibraryMembershipDetailModal =({modalOpen, setModalOpen, libraryList}) => {
    return (
        <Modal
            titleText={'사용할 수 있는 도서관'}
            isShowing={modalOpen}
            onClose={() => setModalOpen(false)}
            size={'xl'}

            body={
                <div className="row">
                    {libraryList.map(library => (
                        <div className="col-12 col-sm-6">
                            <LibraryCard library={library} backgroundColorType={'card-card'}/>
                        </div>
                    ))}
                </div>
            }
        />
    )
}

export default LibraryMembershipDetailLibraryCard

const LibraryImage = styled.img.attrs({
    className: 'img-fluid',
})`
    width: 28px;
    margin-bottom: 5px;
`
